export const FullImage = ({ src, alt, testid }) => (
  <section className="w-full" data-testid={testid}>
    <img src={src} alt={alt} className="h-[45vh] w-full object-cover md:h-[65vh]" />
  </section>
);
